import React, { useContext, useRef, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { Stack } from '@mui/material';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';

import { LeftMenu, PathRestoration } from '@@components';

import { Permissions } from '../common/Permissions';
import AuthContext from '../components/AuthContext';
import ArchitectAssistant from '../components/Chat/ArchitectAssistant';
import { DesignerScreenContextProvider } from '../components/Chat/DesignerScreenContext';
import { useChangeSet } from '../components/ChangeSetContext';
import { useCurrentUserPermissions } from '../components/CurrentUserPermissionsContext';

export default function MainLayout2() {
	const { currentChangeSetId } = useChangeSet();
	const [architectState, setArchitectState] = useState<'closed' | 'expanded' | 'minimized' | 'dismissed'>('closed');
	const contentRef = useRef<HTMLElement>(null);
	const auth = useContext(AuthContext);
	const { hasPermission, isLoading } = useCurrentUserPermissions();
	const canUseArchitect = auth.isAuthenticated && !isLoading && hasPermission(Permissions.ConversationRead) && hasPermission(Permissions.ConversationUpdate);
	return (
		<DesignerScreenContextProvider currentChangeSetId={currentChangeSetId}>
			<Stack
				direction="row"
				sx={{
					width: '100vw',
					overflow: 'hidden',
					backgroundColor: 'background.gutter',
					backgroundImage: (theme) =>
						`linear-gradient(to bottom, ${theme.palette.background.gutter}, ${theme.palette.background.gutterGradientTo ?? theme.palette.background.gutter})`,
				}}
			>
				<CssBaseline />
				<PathRestoration />
				<LeftMenu onOpenArchitect={() => setArchitectState('expanded')} />
				{canUseArchitect && architectState !== 'closed' && (
					<ArchitectAssistant
						key={auth.account?.homeAccountId ?? auth.account?.localAccountId}
						expanded={architectState === 'expanded'}
						onMinimize={() => setArchitectState('minimized')}
						onExpand={() => setArchitectState('expanded')}
						contentRef={contentRef}
						visible={architectState !== 'dismissed'}
						onDismiss={() => setArchitectState('dismissed')}
					/>
				)}
				<Box
					component="main"
					ref={contentRef}
					sx={{
						flexGrow: 1,
						minWidth: 0,
						display: 'flex',
						flexDirection: 'column',
						height: '100vh',
						overflowX: 'hidden',
						position: 'relative',
						backgroundColor: 'background.gutter',
						backgroundImage: (theme) =>
							`linear-gradient(to bottom, ${theme.palette.background.gutter}, ${theme.palette.background.gutterGradientTo ?? theme.palette.background.gutter})`,
					}}
				>
					<Outlet />
				</Box>
			</Stack>
		</DesignerScreenContextProvider>
	);
}
